import styled from 'styled-components';
import {rem} from 'polished';

export const Container = styled.div`
    color: ${({theme}) => theme.color?.publishDate};
    font-size: ${rem('14px')};
    line-height: ${rem('19px')};

    @media only screen and (min-width: ${({theme}) => theme.breakpoint.tablet}) {
        text-align: right;
    }
`;

export const Time = styled.time`
    margin: 0 ${rem('4px')};
`;
